module.exports = __webpack_public_path__ + "img/vision.666c9cd6.jpg";